import { render, staticRenderFns } from "./myRepairList.vue?vue&type=template&id=60894ceb&scoped=true"
import script from "./myRepairList.vue?vue&type=script&lang=js"
export * from "./myRepairList.vue?vue&type=script&lang=js"
import style0 from "./myRepairList.vue?vue&type=style&index=0&id=60894ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60894ceb",
  null
  
)

export default component.exports